import { getIsFeatureHasAnOption } from 'src/utils/featureToggle';

/**
 * Включает новую валидацию туристов
 */
export const IS_NEW_TOURIST_VALIDATION = getIsFeatureHasAnOption(
  'new_tourist_validation',
  'on',
);
